import { UserRole, ChecklistItemTypeUserRolesMap, ChecklistItemType } from "./types";
import _ from "lodash";

const checklistItemTypeUserRolesMap: ChecklistItemTypeUserRolesMap = {
  [ChecklistItemType.AllItemsReturned]: [UserRole.RefundsAdmin],
  [ChecklistItemType.AllItemsConfirmedUnworn]: [UserRole.RefundsAdmin],
  [ChecklistItemType.WithinBudget]: [],
  [ChecklistItemType.EligibleForRefund]: [UserRole.RefundsAdmin],
};

export const allowedToModifyChecklistItem = (checklistItemType: ChecklistItemType, userRoles: UserRole[]): boolean => {
  const allowedRoles = checklistItemTypeUserRolesMap[checklistItemType] || [];

  if (allowedRoles.length === 0) {
    return true;
  }

  return _.intersection(userRoles, allowedRoles).length > 0;
};
